import { createRouter, createWebHistory } from 'vue-router';

/* Le view sono caricate in lazy: l'originale importava tutti e dieci i
 * componenti staticamente, quindi il primo caricamento portava dentro anche
 * la ricerca, il profilo e la 404. */
const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/HomeView.vue'),
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('@/views/SearchView.vue'),
  },
  {
    path: '/pin-creation/from-url',
    name: 'pin-from-url',
    component: () => import('@/views/PinFromUrlView.vue'),
  },
  /* ATTENZIONE all'ordine: `/pins/:pinId` deve stare *dopo* le tre rotte più
   * specifiche, altrimenti `/pins/tags/foo` verrebbe catturata come
   * pinId="tags". Era già così nell'originale, ma senza che nulla lo dicesse. */
  {
    path: '/pins/tags/:tag',
    name: 'pins-by-tag',
    component: () => import('@/views/PinsView.vue'),
    props: (route) => ({ tag: route.params.tag }),
  },
  {
    path: '/pins/users/:username',
    name: 'pins-by-user',
    component: () => import('@/views/PinsView.vue'),
    props: (route) => ({ username: route.params.username }),
  },
  {
    path: '/pins/boards/:boardId',
    name: 'pins-by-board',
    component: () => import('@/views/PinsView.vue'),
    props: (route) => ({ boardId: route.params.boardId }),
  },
  {
    path: '/pins/:pinId',
    name: 'pin',
    component: () => import('@/views/PinsView.vue'),
    props: (route) => ({ pinId: route.params.pinId }),
  },
  {
    path: '/boards/users/:username',
    name: 'boards-by-user',
    component: () => import('@/views/BoardsView.vue'),
    props: true,
  },
  {
    path: '/profile/:username',
    name: 'profile',
    component: () => import('@/views/ProfileView.vue'),
    props: true,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/views/NotFoundView.vue'),
  },
];

export default createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, saved) {
    // Tornando indietro si riprende da dove si era: in una griglia infinita
    // ripartire dall'alto è particolarmente fastidioso.
    return saved ?? { top: 0 };
  },
});
